import React, { MouseEventHandler, PropsWithChildren, useRef } from 'react'
import clsx from 'clsx'
import { Loader } from '@components/ui-css/Loader'
import styles from './styles/Button.module.scss'

export type ButtonProps = {
  onClick?: () => void
  onMouseEnter?: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>
  variant?: 'contained' | 'outlined'
  color?: 'primary' | 'secondary' | 'tertiary'
  size?: 'small' | 'medium' | 'big'
  disabled?: boolean
  isLoading?: boolean
  style?: React.CSSProperties
  className?: string
  type?: 'button' | 'submit' | 'reset'
  form?: string

  /**
   * FIXME: remove and push disabling to parent
   * @deprecated
   */
  disableOnClick?: boolean
  id?: string
} & PropsWithChildren

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  /**
   * FIXME: remove with disableOnClick prop
   */
  const buttonRef = useRef<HTMLButtonElement>(null)

  const {
    onClick,
    onMouseEnter,
    className,
    children,
    style,
    variant = 'contained',
    color = 'primary',
    disabled,
    isLoading,
    size = 'medium',
    disableOnClick,
    ...rest
  } = props

  /**
   * FIXME: remove with disableOnClick prop
   * The current implementation has no way to re-enable the button
   */
  const handleClick = () => {
    if (disableOnClick) {
      if (buttonRef.current && !buttonRef.current.disabled) {
        buttonRef.current.disabled = true
        onClick?.()
      }
    } else {
      onClick?.()
    }
  }

  return (
    <button
      ref={ref ?? buttonRef}
      className={clsx(styles.button, styles[variant], styles[color], styles[size], className)}
      onClick={handleClick}
      onMouseEnter={onMouseEnter}
      style={style}
      disabled={disabled || isLoading}
      data-variant={variant}
      data-color={color}
      {...rest}
    >
      {isLoading && <Loader variant={variant === 'outlined' && !disabled ? 'dark' : 'light'} />}
      {children}
    </button>
  )
})
